export default "__VITE_ASSET__DoQyOW3V__"